import { throttleComplete } from '@utils/throttle';
const handlePageScroll = () => {
    const scrollOffset = 10;
    const pageElement = document.querySelector('.page');
    if (document.body.scrollTop > scrollOffset) {
        pageElement === null || pageElement === void 0 ? void 0 : pageElement.classList.add('page--scrolled');
    }
    else {
        pageElement === null || pageElement === void 0 ? void 0 : pageElement.classList.remove('page--scrolled');
    }
};
window.addEventListener('scroll', throttleComplete(handlePageScroll, 100));
